import { render, staticRenderFns } from "./CategoryBoxLinks.vue?vue&type=template&id=c90d0db4&scoped=true&"
import script from "./CategoryBoxLinks.vue?vue&type=script&lang=js&"
export * from "./CategoryBoxLinks.vue?vue&type=script&lang=js&"
import style0 from "./CategoryBoxLinks.vue?vue&type=style&index=0&id=c90d0db4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c90d0db4",
  null
  
)

export default component.exports